<template>
  <div :class="`view faq ${page}`">
    <div class="blocks">
      <div class="block tr">
        <h1>
          <div>{{ page === 'companies' ? "Unternehmen" : "Kandidaten" }}</div>
          <div class="subtitle">F.A.Q</div>
        </h1>
      </div>
      <div class="block">
        <!-- <img :src="require(`@/assets/tr_p_${page}_faq@2x.jpg`)" class="faq-picture"> -->
        <div class="faq-picture" :style="{backgroundImage: `url(${require(`@/assets/tr_p_${page}_faq@2x.jpg`)})`}"></div>
        <div class="faq-picture-mobile" :style="{backgroundImage: `url(${require(`@/assets/tr_p_${page}_faq.jpg`)})`}"></div>
      </div>
    </div>
    <div class="faq-content">
      <router-link v-if="page !== 'companies'" class="back" :to="`/${page}`">&lt; zurück</router-link>
      <div class="questions">
        <router-link class="btn" to="/contact">
          <span>Kontakt</span>
          <i class="fas fa-long-arrow-alt-right"></i>
        </router-link>
        <a class="question" v-for="(question, i) in questions" :key="`question_${i}`" :selected="i === selectedIndex" @click="selectedIndex = i">
          <span>{{question.question}}</span>
          <i class="fas fa-book-open" v-if="i === selectedIndex"></i>
          <i class="fas fa-plus" v-else></i>
        </a>
      </div>
      <div class="answer" v-if="selectedQuestion">
        <div
          :class="['answer-item', getPosition(selectedIndex, i)]"
          v-for="(question, i) in questions"
          :key="`answer_${i}`"
          v-html="question.answer"></div>
      </div>
    </div>
    <div class="faq-content mobile">
      <div class="questions">
        <a class="question" v-for="(question, i) in questions" :key="`question_${i}`" :selected="i === selectedIndex" @click="selectedIndex = $el.clientWidth <= 1024 && selectedIndex === i ? null : i">
          <div class="question-text">
            <span>{{question.question}}</span>
            <i class="fas fa-book-open" v-if="i === selectedIndex"></i>
            <i class="fas fa-plus" v-else></i>
          </div>
          <div class="question-answer">
            <div v-html="question.answer"></div>
          </div>
        </a>
      </div>
      <router-link class="btn" to="/contact">Kontakt</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'faq',
  computed: {
    questions() {
      return this.qa[this.$route.name] || []
    },
    selectedQuestion() {
      return this.questions[this.selectedIndex] || null
    },
    page() {
      return this.$route.name.split('-').shift()
    }
  },
  data() {
    return {
      selectedIndex: window.innerWidth <= 1024 ? null : 0,
      isMobile: (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1),
      qa: {
        'companies-faq': [
          {
            question: 'Warum THRONE-Recruiting?',
            answer: `<p>Als rein auf den HR-Bereich spezialisierter Recruiting-Partner stehen wir auf Kandidatenseite auch ausschließlich mit Fach- und Führungskräften aus diesem Bereich in Kontakt. Wir bieten Ihnen Zugang zu diesem exklusiven Kandidaten-Pool, um Ihre HR-Schlüsselposition schnell und diskret zu besetzen.</p>`
          },
          {
            question: 'Welche Berufsfelder decken wir ab?',
            answer: `<p>Wir sind rein auf die Besetzung von HR-Positionen auf Fach- und Führungsebene spezialisiert. Das Spektrum reicht von den klassischen Referenten-, über die verschiedenen Spezialisten- (wie z.B. Payroll, Personalentwicklung, Recruiting, Employer Branding, Compensation & Benefits, Arbeitsrecht etc. ) bis hin zu HR-Führungspositionen auf Director- und VP-Level.</p>`
          },
          {
            question: 'In welchen Regionen sind wir tätig?',
            answer: `<p>Wir sind in der gesamten DACH-Region für Sie aktiv. Gern unterstützen wir Sie jedoch auch, wenn Sie darüber hinaus eine HR-Position zu besetzen haben. In der Vergangenheit haben wir bereits Positionen in Kopenhagen, London oder auch in den USA besetzt.</p>`
          },
          {
            question: 'Wie kommen wir an passende Kandidaten für Ihre Vakanz?',
            answer: `<p>In den letzten Jahren haben wir uns ein Netzwerk von aktuell über 14.000 Fach- und Führungskräften aus dem HR-Bereich aufgebaut. Auf dieses bestehende Netzwerk greifen wir bei einem neuen Mandat in der Regel als erstes zurück. Meist gehen wir parallel dazu noch per Direktansprache in den Markt, um Ihnen die bestmögliche Auswahl an aktuell wechselwilligen Kandidaten vorstellen zu können.</p>`
          },
          {
            question: 'Wie lange dauert es bis wir Ihnen Kandidaten vorstellen?',
            answer: `<p>Unser Anspruch ist es, Ihnen innerhalb von 48 Stunden nach Auftragserteilung die ersten Profile vorstellen zu können.</p>`
          },
          {
            question: 'Bieten wir auch Executive Search?',
            answer: `<p>Ja. In enger Abstimmung mit Ihnen besprechen wir das genaue Such-Profil und berücksichtigen Ihre Anforderungen, definieren Zielbranchen, Zielfirmen und erstellen eine Unternehmens-Blacklist, sowie - falls gewünscht - eine (exklusive) Stellenausschreibung.</p>`
          },
        ],
        'candidates-faq': [
          {
            question: 'Warum THRONE-Recruiting?',
            answer: `<p>Als rein auf den HR-Bereich spezialisierter Recruiting-Partner stellen wir Ihnen regelmäßig spannende HR-Positionen vor und bieten Ihnen exklusiven Zugang zu den Positionen unserer Mandanten. Dabei stellen wir Sie immer bei den Entscheidungsträgern vor. Uns ist es wichtig die für Sie bestmögliche Option innerhalb der HR-Branche zu finden und bieten Ihnen daher eine individuelle Betreuung vom Erstkontakt bis hin zur finalen Vertragsunterschrift.</p>`
          },
          {
            question: 'Wie kann ich mich bewerben?',
            answer: `<p>Senden Sie uns gerne Ihre Unterlagen an <a href="mailto:bewerbung@throne-recruiting.com">bewerbung@throne-recruiting.com</a> oder nutzen Sie unser <a href="/contact" target="_blank">Kontaktformular</a>.</p>`
          },
          {
            question: 'Was passiert nachdem ich mich beworben habe.',
            answer: `<p>Nach Eingang Ihrer Bewerbungsunterlagen setzen wir uns so schnell wie möglich mit Ihnen in Verbindung. Wir möchten verstehen, was Sie bewegt, warum es Sie bewegt und wie wir Sie dabei unterstützen können, den nächsten Schritt in Ihrer Karriere zu gehen?<p>`
          },
          {
            question: 'Was passiert mit meinen Daten?',
            answer: `<p>Selbstverständlich behandeln wir jegliche Informationen, die Sie mit uns teilen diskret und unter Einhaltung der EU-DSGVO. Eine Vorstellung Ihrer Person bzw. die Weiterleitung Ihrer Unterlagen an unsere Mandanten findet ausschließlich nach Ihrer schriftlichen Einwilligung statt.</p>`
          },
          {
            question: 'Kostet mich der Service von THRONE-Recruiting etwas?',
            answer: `<p>Nein. Unser Service ist für Sie als Kandidat zu jeder Zeit komplett kostenfrei.</p>`
          },
        ],
      }
    }
  },
  watch: {
    selectedIndex(index) {
      const answers = this.$el.querySelectorAll('.question-answer')
      answers.forEach(el => el.removeAttribute('style'))
      if(isNaN(index) || !this.isMobile) return
      this.$nextTick(() => {
        const el = answers[index]
        if(el) {
          el.style.transition = 'none'
          el.style.height = 'auto'
          window.requestAnimFrame(() => {
            const pos = el.getBoundingClientRect()
            el.style.transition = null
            el.style.height = 0
            window.requestAnimFrame(() => {
              el.style.height = pos.height + 'px'
            })
          })
        }
      })
    }
  },
  methods: {
    getPosition(index, i) {
      const dir = i - index
      if(dir > 0) return 'after'
      if(dir < 0) return 'before'
      return 'current'
    }
  },
  mounted: function() {
    this.$store.commit('setTransition', false)
  }
}
</script>

<style scoped>
.faq {
  padding: 9.26vh 7.08vw 0;
}

.faq h1 {
  position: relative;
  display: inline-block;
  font: 400 4.72vh/1 'Exodus Demo St';
  color: #ffd675;
  margin: 0 .94vw 0 0;
  padding-top: 12.59vh;
}

.faq h1 .subtitle {
  text-align: center;
  font: 300 1.3vh/1 'Avenir';
  margin-top: 1.48vh;
  letter-spacing: .05em;
}

.faq h1 .subtitle:before,
.faq h1 .subtitle:after {
  content: '';
  display: inline-block;
  vertical-align: middle;
  width: 4.4vw;
  height: 1px;
  background: #ffd675;
  margin: 0 .52vw;
}

.faq h1:before {
  content: '';
  display: block;
  width: 11.66vw;
  height: 8px;
  background: url(../assets/tr_o_title-line.svg) no-repeat center/contain;
  margin: 0 auto 1.85vh;
}

.faq h1:after {
  content: '';
  position: absolute;
  top: 1.48vh;
  left: 0;
  right: 0;
  margin: 0 auto 1.48vh;
  width: 9.63vh;
  height: 9.63vh;
  background: url(../assets/tr_ic_companies.svg) no-repeat center/contain;
}

.faq.candidates h1:before {
  background: none;
}

.faq.candidates h1:after {
  top: 2.5vh;
  width: 11.66vw;
  height: 12vh;
  transform: translateX(-.03vw);
  background-image: url(../assets/tr_ic_candidates.svg);
}

.faq .faq-picture {
  width: 35.94vw;
  height: 20.83vh;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.blocks,
.faq-content {
  display: flex;
}

.blocks {
  position: relative;
  z-index: 1;
}

.blocks .block,
.faq-content > * {
  width: 50%;
}

.blocks .block.tr {
  text-align: right;
}

.faq-content {
  position: relative;
  height: 55.37vh;
  background: rgba(82, 82, 102, 0.23);
  margin-top: -4.75vh;
  align-items: center;
}

.faq-content.mobile {
  display: none;
}

.faq-content:after {
  content: '';
  position: absolute;
  width: 1.66vh;
  height: 1.66vh;
  background: url(../assets/tr_ic_squares.svg) no-repeat center/contain;
  bottom: -.83vh;
  left: -.83vh;
}

.faq-content .back {
  position: absolute;
  left: 0;
  bottom: 100%;
  font-size: 1.3vh;
  font-weight: 500;
  letter-spacing: .4em;
  margin-bottom: 10px;
  color: #fff;
  z-index: 2;
}

.faq-content .questions {
  position: relative;
  padding: 0 3.9vw 0 10.94vw;
}

.faq-content .questions .question {
  display: flex;
  justify-content: space-between;
  font-size: .84vw;
  letter-spacing: .2em;
  padding: .84vw 0;
  border-bottom: 1px solid rgb(255, 214, 117, .23);
}

.faq-content .questions .question:last-child {
  border: none;
}

.faq-content .questions .question[selected] {
  font-weight: 800;
}

.faq-content .questions .question i {
  font-size: .73vw;
  margin-right: .19vw;
  margin-top: .15vw;
  margin-left: 2.92vw;
}

.faq-content .questions > .btn {
  position: absolute;
  top: calc(100% + .75vw);
  left: 4vw;
  font-size: .73vw;
  right: 0;
  margin: auto;
  width: 140px;
  background: #0A1612;
}

.faq-content .questions > .btn i {
  position: absolute;
  opacity: 0;
  transition: all .16s ease-out;
  right: 40px;
}

.faq-content .questions > .btn span {
  transition: transform .16s ease-out;
}

@media screen and (min-width: 1025px) {
  .faq-content .questions > .btn:hover {
    color: #ffd675;
  }
  .faq-content .questions > .btn:hover span {
    transform: translateX(-8px);
  }
  .faq-content .questions > .btn:hover i {
    opacity: 1;
    transform: translateX(8px);
  }
}

.faq-content .answer {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.faq-content .answer .answer-item {
  position: absolute;
  top: 4.75vh;
  left: 0;
  width: 100%;
  padding: 0 5.1vw 0 3.9vw;
  font-size: 1.6vh;
  font-weight: 300;
  line-height: 1.875;
  letter-spacing: .05em;
  transition: transform .16s ease-out, opacity .16s ease-out, .16s left .16s ease-out;
}

.faq-content .answer .answer-item.before {
  transform: translateX(-100%);
  left: 5%;
  opacity: 0;
}

.faq-content .answer .answer-item.after {
  transform: translateX(100%);
  left: -5%;
  opacity: 0;
}

.faq-content .answer .answer-item >>> p {
  margin: 2.96vh 0;
}

@media screen and (max-width: 1024px) {
  .faq {
    padding: 0;
  }
  .faq h1 {
    display: block;
    font-size: 34px;
    margin: 0 0 32px;
    padding-top: 118px;
  }
  .faq h1:after {
    width: 104px;
    height: 104px;
    top: 0;
  }
  .faq.candidates h1:after {
    background-image: url(../assets/tr_m_ic_candidates.svg);
  }
  .faq h1 .subtitle {
    margin-top: 8px;
    font-size: 15px;
    white-space: nowrap;
  }
  .faq h1 .subtitle:before,
  .faq h1 .subtitle:after {
    width: 35vw;
    height: 5px;
    background: url(../assets/tr_o_title-single-line.svg) no-repeat center right/contain;
    margin: 0 10px 0 0;
  }
  .faq h1 .subtitle:after {
    transform: rotateY(180deg);
    background-position: center left;
    margin: 0 0 0 10px;
  }
  .faq-content,
  .faq h1:before,
  .faq-content:after,
  .faq .faq-picture {
    display: none;
    margin: 0;
  }
  .faq-content.mobile,
  .blocks {
    display: block;
    background: none;
    height: auto;
  }
  .blocks .block,
  .blocks .block.tr {
    width: auto;
    text-align: center;
  }
  .faq .faq-picture {
    width: 100%;
  }
  .faq .faq-picture-mobile {
    padding-top: 46.86%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-bottom: 56px;
  }
  .faq-content .questions {
    width: auto;
    padding: 0 30px;
  }
  .faq-content.mobile > .btn {
    display: flex;
    width: calc(100% - 84px);
    margin: 52px auto 0;
    height: 72px;
    background:#ffd675;
    color:#0A1612;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: .3em;
  }
  .faq-content .questions .question {
    display: block;
    font-size: 14px;
    padding: 24px 0 0;
    font-weight: 300;
  }
  .faq-content .questions .question .question-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .faq-content .questions .question .question-answer {
    position: relative;
    background:rgba(82, 82, 102, 0.23);
    color: #fff;
    font-size: 16px;
    line-height: 1.875;
    font-weight: 300;
    margin: 24px -30px 0;
    height: 0;
    /* box-sizing: unset; */
    overflow: hidden;
    transition: height .16s ease-out;
  }
  .faq-content .questions .question .question-answer > div {
    /* height: auto; */
    padding: 24px 30px;
  }
  .faq-content .questions .question i {
    display: block;
    margin: 0;
    padding: 4px;
    font-size: 14px;
  }
}
</style>
